import { render, staticRenderFns } from "./MatchPagination.vue?vue&type=template&id=dd35dbd4&scoped=true"
import script from "./MatchPagination.vue?vue&type=script&lang=js"
export * from "./MatchPagination.vue?vue&type=script&lang=js"
import style0 from "./MatchPagination.vue?vue&type=style&index=0&id=dd35dbd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd35dbd4",
  null
  
)

export default component.exports